import { BqTag } from '~/components/ui/misc/bqTag/BqTag';

export function InvestorCellObligationsAg(props: { value: { name: string } }) {
  if (!props.value.name) {
    return '-';
  }
  return <BqTag color="info" value={props.value.name} />;
}
